<div class="picklist-holder">
  <div class="picklist-center">


    <div class="createDelete">
      <div class="textButtonRow">

          <div [hidden]="createButtonClicked">
            <kendo-floatinglabel text="Group ID...">
              <kendo-combobox
                class="combobox"
                [data]="groupIdList"
                [valueField]="'groupId'"
                [textField]="'groupId'"
                (valueChange)="groupIdValueChange($event)"
                [(ngModel)]="selectedGroupId"
              >
              </kendo-combobox>
            </kendo-floatinglabel>
          </div>

        <div [hidden]="!createButtonClicked">
        <kendo-floatinglabel text="Group ID: ">
          <input [disabled]="false" name="defaultGL" [(ngModel)]="groupIdValue" (ngModelChange)="groupDescValueChange($event)" kendoTextBox/>
        </kendo-floatinglabel>
        </div>

        <app-mcl-button class="buttonFixedWidth" text="Create" primary="true" (click)="createClicked()">
        </app-mcl-button>
      </div>

      <div class="textButtonRow">
        <div>
        <kendo-floatinglabel text="Group Description: ">
          <input [disabled]="false" name="defaultGL" [(ngModel)]="groupDescValue" kendoTextBox/>
        </kendo-floatinglabel>
        </div>
        <app-mcl-button [hidden]="createButtonClicked" class="buttonDelete" text="Delete" (click)="deleteClicked($event)">
        </app-mcl-button>
        <app-mcl-button [hidden]="!createButtonClicked" class="buttonDelete" text="Cancel" (click)="cancelClicked($event)">
        </app-mcl-button>
      </div>
    </div>
    <app-picklist
      [firstSelectorActive]="false"
      [secondSelectorActive]="false"
      [parentGridChange] = "parentGridChange"
      [firstLabelName]="firstLabelName"
      [currentAssigned]="storeGroupListA"
      [currentAvailable]="storeGroupListU"
      (formResults)="pickListFormResults($event)"
    >
    </app-picklist>
  </div>
</div>
<div kendoDialogContainer></div>
